import React from 'react'
import ControlTowerCards from './child/ControlTowerCards';
import ControlTowerTables from './child/ControlTowerTables';

const ControlTowerLayer = () => {
    return (
        <>
            {/* Cards Section */}
            <ControlTowerCards />

            <section className="row gy-4 mt-1">
                {/* Tables Section */}
                <div className="col-12">
                    <ControlTowerTables />
                </div>
            </section>
        </>
    )
}

export default ControlTowerLayer
